import { render } from "./Pinterest.vue?vue&type=template&id=2a430cf4&lang=html"
import script from "./Pinterest.vue?vue&type=script&lang=js"
export * from "./Pinterest.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__